module.exports = __webpack_public_path__ + "static/media/84.f7ed1644.png";